module.exports = __webpack_public_path__ + "img/haixian_b.81a2b372.png";